import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, map, switchMap } from 'rxjs';
import { ApiService } from 'src/app/api/api.service';
import { SessionService } from 'src/app/auth/services/session.service';
import { randomString } from 'src/app/shared/helpers/auth-utils/auth.utils';
import {AnvandareDTO, OrganisationDTO, UserOrganisationsDTO} from './anvandare.models';

@Injectable({
  providedIn: 'root',
})
export class AnvandareService {
  private apiService = inject(ApiService);
  private sessionService = inject(SessionService);
  private destroy = inject(DestroyRef);



  public anvandareOrganisationChange$ = new BehaviorSubject<boolean>(false);

  getAnvandareByOrg<T>() {
    return this.apiService.postAsObservable<T>('user/search');
  }

  updateAnvandare(anvandare: AnvandareDTO) {
    anvandare.anvandareOrganisationer.forEach(org => org.id = randomString(40))
    return this.apiService.putAsObservable(`user/${anvandare.id}`, anvandare);
  }

  createAnvandare(anvandare: AnvandareDTO) {
    return this.apiService.postAsObservable(`user/create`, anvandare);
  }

  getAllOrganisations() {
    return this.apiService.getAsObservable<OrganisationDTO[]>('kml')
  }

  listaAnvandare<T>() {
     return this.apiService.getAsObservable<T>('user/getAllUsers')

  }

  getUserById(id: string) {
    return this.apiService.getAsObservable<AnvandareDTO>(`user/${id}`)
  }

  getUserGroupsById(id: string){
    return this.apiService.getAsObservable<UserOrganisationsDTO>(`user/orgs/${id}`)
  }

  getLoggedInUserOrganisations() {
    const userId = this.sessionService.getUserId();
    return this.getUserGroupsById(userId).pipe(map(user => user.anvandareOrganisationer));
  }

  loginAnvandareOrganisation(chosenOrgId: string) {
    const userId = this.sessionService.getUserId();
    return this.getUserById(userId).pipe(map(user => {
      user.theChosenOrgId = chosenOrgId;
    }))
  }

}
